/**
 * Scheduler Constants
 * Centralized configuration for the scheduler module
 */

// Shift calculation thresholds
export const SHIFT_GAP_THRESHOLD_MINUTES = 60; // Gap threshold for defining separate shifts
export const SPLIT_SHIFT_MIN_GAP_HOURS = 1; // Minimum gap to trigger split shift warning
export const SPLIT_SHIFT_MAX_GAP_HOURS = 8; // Maximum gap for split shift (beyond this is separate shift)
export const LONG_SHIFT_THRESHOLD_HOURS = 8.5; // Maximum shift length before warning

// Default patrol values
export const DEFAULT_PATROL_DURATION_HOURS = 1;
export const MIN_PATROL_DURATION_HOURS = 0.5;
export const PATROL_DURATION_STEP_HOURS = 0.5;

// Calendar zoom configuration
export const CALENDAR_ZOOM_MIN = 0.5; // Minimum zoom level (50%)
export const CALENDAR_ZOOM_MAX = 4.0; // Maximum zoom level (400%)
export const CALENDAR_ZOOM_STEP = 0.5; // Zoom increment/decrement step (50%)
export const CALENDAR_ZOOM_DEFAULT = 1.0; // Default zoom level (100%)
export const CALENDAR_TIMESLOT_BASE_HEIGHT = 48; // Base height for each hour timeslot in pixels at 100% zoom

export const SHIFT_COLORS = [
  { bg: '#E3F2FD', border: '#1976D2', text: '#0D47A1' }, // Blue
  { bg: '#F3E5F5', border: '#7B1FA2', text: '#4A148C' }, // Purple
  { bg: '#E8F5E9', border: '#388E3C', text: '#1B5E20' }, // Green
  { bg: '#FFF3E0', border: '#F57C00', text: '#E65100' }, // Orange
  { bg: '#FCE4EC', border: '#C2185B', text: '#880E4F' }, // Pink
  { bg: '#E0F7FA', border: '#0097A7', text: '#006064' }, // Cyan
  { bg: '#FFF8E1', border: '#FFA000', text: '#FF6F00' }, // Amber
  { bg: '#F1F8E9', border: '#689F38', text: '#33691E' }, // Light Green
  { bg: '#EDE7F6', border: '#512DA8', text: '#311B92' }, // Deep Purple
  { bg: '#FFEBEE', border: '#D32F2F', text: '#B71C1C' }, // Red
];

// Break visualization
export const BREAK_VISUAL_OFFSET_MINUTES = 1; // Subtract from visual end to prevent overlap

// Week configuration
export const WEEK_START_DAY = 1; // Monday = 1 (ISO week standard)

// API retry configuration
export const API_RETRY_COUNT = 3; // Number of retry attempts for transient failures
export const API_RETRY_DELAY_MS = 1000; // Base delay between retries (exponential backoff)

// Debounce configuration
export const SCHEDULE_LOAD_DEBOUNCE_MS = 300; // Debounce delay for schedule loading
